import { useContext } from 'react';
import PropTypes from 'prop-types';
import { TRANSACTION_PARTY_TYPE } from 'components/constants';
import countries from 'components/countries';
import i18nContext from 'components/i18n-context';
import Input from 'uikit/Input/Input';
import { InputDropDownSearch } from 'uikit/InputDropDown/InputDropDownSearch';

export const getPartyTypeOptions = (i18n) =>
  Object.values(TRANSACTION_PARTY_TYPE).map((type) => ({
    key: type,
    title: i18n.getMessage(`transactionPartyType.${type}`)
  }));

// Beneficiary of an external recipient (its type is chosen in the section header) together with its address
const BeneficiarySection = ({ values, errors, isCountryRequired, handleChange, setFieldValue, validateField }) => {
  const i18n = useContext(i18nContext);

  const countriesOptions = Object.values(countries).map((value) => ({
    key: value,
    value: i18n.getMessage(value)
  }));

  const renderInput = (name, label, isRequired = false) => (
    <Input
      isRequired={isRequired}
      className={'repeat-transaction-input'}
      label={label}
      id={name}
      name={name}
      value={values[name]}
      onChange={handleChange}
      onBlur={() => validateField(name)}
      error={errors?.[name]}
    />
  );

  return (
    <>
      <div className={'repeat-transaction-row-block'}>
        {values.partyType === TRANSACTION_PARTY_TYPE.INDIVIDUAL ? (
          <>
            {renderInput('partyFirstName', i18n.getMessage('createTransaction.payment.firstName'), true)}
            {renderInput('partyLastName', i18n.getMessage('createTransaction.payment.lastName'), true)}
          </>
        ) : (
          <>
            {renderInput('partyCompanyName', i18n.getMessage('createTransaction.payment.companyName'), true)}
            {renderInput('registrationNumber', i18n.getMessage('createTransaction.payment.registrationNumber'))}
          </>
        )}
      </div>

      <div className={'repeat-transaction-subsection'}>
        <div className={'repeat-transaction-row-block'}>
          {renderInput('partyAddress', i18n.getMessage('createTransaction.repeat.address.address'))}
          {renderInput('partyCity', i18n.getMessage('createTransaction.repeat.address.city'))}
        </div>

        <div className={'repeat-transaction-row-block'}>
          {renderInput('partyPostCode', i18n.getMessage('createTransaction.repeat.address.postCode'))}
          {renderInput('partyState', i18n.getMessage('createTransaction.repeat.address.state'))}
          <InputDropDownSearch
            isRequired={isCountryRequired}
            className={'repeat-transaction-search-select'}
            label={i18n.getMessage('createTransaction.repeat.address.country')}
            id={'partyCountry'}
            name={'partyCountry'}
            options={countriesOptions}
            value={values.partyCountry}
            onChange={setFieldValue}
            onBlur={() => validateField('partyCountry')}
            error={errors?.partyCountry}
          />
        </div>
      </div>
    </>
  );
};

BeneficiarySection.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isCountryRequired: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired
};

export default BeneficiarySection;
